// Icons Material can be defined here, not fontAwesome
import HomeIcon from "@material-ui/icons/Home";

import {
  Cohort,
  PicTreeHome,
  PicTreeCheckIn,
  PicTreeMap,
  PicTreeReviewSummary,
  PicTreeReviewByAssetTypeTepco,
  PicTreeMissionSummary,
  PicTreeMissionRanking,
  PicTreeMissionReport,
  PicTreeReportSummary,
  PicTreeReportTsuruSummary,
  PicTreeReportCountByUsers,
} from "pages";

export default {
  items: [
    {
      path: "/game/pictree/tepco/home",
      name: "ホーム",
      type: "link",
      icon: HomeIcon,
      component: PicTreeHome,
      sideBar: true,
      divider: true,
    },
    {
      path: "/game/pictree/tepco/checkin",
      name: "チェックイン",
      type: "link",
      icon: false,
      component: PicTreeCheckIn,
      sideBar: true,
      divider: false,
    },
    {
      path: "/game/pictree/tepco/photos",
      name: "通常モード",
      type: "submenu",
      category: "撮影",
      sideBar: true,
      children: [
        {
          path: "/overview",
          name: "概要",
          icon: null,
          component: PicTreeReviewSummary,
        },
        {
          path: "/asset-type",
          name: "アセットタイプ別",
          type: "link",
          icon: false,
          component: PicTreeReviewByAssetTypeTepco,
          sideBar: true,
          divider: true,
        },
        {
          path: "/map",
          name: "地図表示",
          icon: null,
          component: PicTreeMap,
        },
        // {
        //   path: "/denchu/appearance",
        //   name: "出現回数 - 電柱",
        //   icon: null,
        //   component: PicTreeReviewAppearance,
        // },
      ]
    },
    {
      path: "/game/pictree/tepco/mission",
      name: "ミッションモード",
      type: "submenu",
      sideBar: true,
      children: [
        {
          path: "/overview",
          name: "概要",
          icon: null,
          component: PicTreeMissionSummary,
        },
        {
          path: "/ranking",
          name: "達成ランキング",
          icon: null,
          component: PicTreeMissionRanking,
        },
      ],
    },
    {
      path: "/game/pictree/tepco/mission/:mid",
      name: "レポート",
      type: "link",
      icon: null,
      component: PicTreeMissionReport,
      sideBar: false,
      agent: true,
    },
    {
      path: "/game/pictree/tepco/report",
      name: "報告モード",
      type: "submenu",
      sideBar: true,
      children: [
        {
          path: "/overview",
          name: "概要",
          icon: null,
          component: PicTreeReportSummary,
        },
        {
          path: "/plant",
          name: "ツルツタ報告",
          icon: null,
          component: PicTreeReportTsuruSummary,
        },
        {
          path: "/report-by-user",
          name: "ユーザー別報告件数",
          icon: null,
          component: PicTreeReportCountByUsers,
        },
      ],
    },
  ],
};
